$(document).ready(function(){

    $('div.product__media-slide a.product__media').each(function () {
    const img = $(this).find('img');
    const alt = img.attr('alt') || 'Product image';
    $(this).attr('aria-label', alt);
});
let Intervaltime_google;
let counter_google = 0; 
$('img[src="https://cdn.convertcart.com/uploads/cc1163c6.png"]').attr('alt', 'perfect mat quiz');


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;
$('a[href="https://cdn.convertcart.com/uploads/250fc5ac.png"]').attr('aria-label', 'Video thumbnail');
$('input.os-e[type="search"]').attr('aria-label', 'Search site');
$('img[src="https://jadeyoga.com/cdn/shop/files/2820_2048x2048.jpg?v=1724787182"]').attr('alt', 'jade cork yoga mat');
   $("div.cc-atc-section-77379794 img").attr("alt","mat");
    if ( $('#goog-gt-votingInputSrcLang').length) {
$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
 
        clearInterval(Intervaltime_google);
       console.log("widget found");
    }
    
  
    if (counter_google >= 50) {
        clearInterval(Intervaltime_google);
       
    }
}
setTimeout(function(){

    $('input#cc-search[type="search"]').attr('aria-label', 'Search site');

$('input.os-e[type="search"]').attr('aria-label', 'Search site');
// Set alt for the question mark icon
$('img[src="https://cdn.convertcart.com/uploads/cc1163c6.png"]').attr('alt', 'Question mark icon');

// Set alt for the Jade Yoga product image
$('img[src="https://jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-Purple_2048x2048.jpg?v=1631573421"]').attr('alt', 'Jade Yoga Harmony Mat in purple color');

// Set aria-labels for navigation buttons
$('button.cc-arrow-left').attr('aria-label', 'Previous item');
$('button.cc-arrow-right').attr('aria-label', 'Next item');

// Set aria-label for close link
$('a[data-close-type="long_close"]').attr('aria-label', 'Close this window');
$("div#smc-v5-overlay-83901 img").attr("alt"," jade yoga selected mat");
},2000)
// Set aria-labels for search inputs

$('img[src="https://cdn.convertcart.com/uploads/250fc5ac.png"]').attr('alt', 'video icon');

let Intervaltime_task;
let counter_task = 0; 


try {
    Intervaltime_task = setInterval(GenerateAriaLabelFortask, 500);
}
catch (err) {
  
}


function GenerateAriaLabelFortask() {
   
   counter_task++;

$('img[src^="https://jadeyoga.com/cdn/shop/products/Jade-Yoga-Harmony-Mat-Purple_2048x2048.jpg"]').attr('alt', 'Jade Yoga Harmony Mat Purple');
$('img[src="https://cdn.convertcart.com/uploads/250fc5ac.png"]').attr('alt', 'Video thumbnail');
$('a[href="https://cdn.convertcart.com/uploads/250fc5ac.png"]').attr('aria-label', 'Product single thumbnail link');
$('iframe[data-testid="shop-cart-sync-iframe"]').attr('title', 'Shop cart synchronization frame');
   
    if ($('a[data-close-type="long_close"].smc-link.smc-closer').length) {

$('a[data-close-type="long_close"].smc-link.smc-closer').attr("aria-label","close link");
        clearInterval(Intervaltime_task);
       
    }
    
  
    if (counter_task >= 20) {
        clearInterval(Intervaltime_task);
       
    }
}
$('img[src="https://cdn.shopify.com/s/files/1/0763/3069/files/Myproject-1_31_2_240x240.jpg?v=1677179880"]').attr('alt', 'This product plants 1 tree');

$('img[src="https://jadeyoga.com/cdn/shop/files/PURPLETWOSIDES_59ff72ea-b54d-499a-bca2-7bb331205154_2048x2048.jpg?v=1717689590"]').attr('alt', 'Purple mat');

$('img[src="//jadeyoga.com/cdn/shop/t/8/assets/blank_1x1.gif?v=50849316544257392421622066539"]').attr('alt', 'Jade Yoga logo');

let Intervaltime_task_1;
let counter_task_1 = 0; 


try {
    Intervaltime_task_1 = setInterval(GenerateAriaLabelFortask_1, 500);
}
catch (err) {
  
}


function GenerateAriaLabelFortask_1() {
   
   counter_task_1++;


   
    if ( $('div#smc-v5-overlay-83901>img').length) {

$('div#smc-v5-overlay-83901>img').attr("alt","jade yoga mat");
        clearInterval(Intervaltime_task_1);
       
    }
    
  
    if (counter_task_1 >= 50) {
        clearInterval(Intervaltime_task_1);
       
    }
}
$("h3:empty").append("<span style='display:none'>.</span>")
$('img[src="https://cdn.shopify.com/s/files/1/0763/3069/files/Cleantheworld2_480x480.png?v=1698419847"]').attr('alt', 'Buy mat wash, Clean the World');
$('a[href="https://online-store-web.shopifyapps.com/admin/online-store/pages/46556165#Albania"]').attr('aria-label', 'Albania');
$('a[href="#austria"]').attr('aria-label', 'Austria');
$('a[href="#bulgaria"]').attr('aria-label', 'Bulgaria');
$('a[href="#colombia"]').attr('aria-label', 'Colombia');
$('a[href="https://jadeyoga.myshopify.com/#hungary"]').attr('aria-label', 'Hungary');
$('a[href="#hungary"]').attr('aria-label', 'Hungary');
$('a[href="#indonesia"]').attr('aria-label', 'Indonesia');
$('a[href="#japan"]').attr('aria-label', 'Japan');
$('a[href="https://jadeyoga.myshopify.com/#malta"]').attr('aria-label', 'Malta');
$('a[href="#malta"]').attr('aria-label', 'Malta');
$('a[href="#russia"]').attr('aria-label', 'Russia');
$('a[href="#singapore"]').attr('aria-label', 'Singapore');
$('a[href="#Albania"]').attr('aria-label', 'Albania');
$('a[href="http://colorpilla.com"]').attr('aria-label', 'Colorpilla website');
$("h3>br:empty").append("<span style='display:none'>.</span>")
$('#RichText--16220676560c384ab8 .rich-text__buttons a[href="/pages/who-we-are"]').attr('aria-label', 'Learn more about Jade yoga');
$('.nav-search[aria-expanded]').attr({
    'role': 'button',
    'tabindex': '0'
});

$("#ProductFeature--16221655373154664d > div > div > div.product-feature__text.product-feature__text--center.rte > a").attr("aria-label","Learn more about matwash")
$('iframe[src^="https://shop.app/pay/hop?analytics_trace_id"]').attr('title', 'Shopping cart sync');
$('div.list-collections__item.carousel__item.one-third[aria-hidden="true"]').removeAttr('aria-hidden');


console.log("ready1");
});
